import React from 'react';
import '@lumx/core/lumx.css';
import './styles/global.css';
import { WizardProvider, useWizard } from './context/WizardContext';
import { OrgDataProvider } from './context/OrgDataContext';
import Sidebar from './components/Sidebar';
import OrgAssignmentPage from './components/OrgAssignmentPage';
import MigrationProgressPage from './components/MigrationProgressPage';
import GroupReconciliationPage from './components/GroupReconciliationPage';
import DeploymentPage from './components/DeploymentPage';
import PostDeploymentPage from './components/PostDeploymentPage';
import PlatformGroupsPage from './components/PlatformGroupsPage';
import OrgUnitsLocationsPage from './components/OrgUnitsLocationsPage';
import TestDeploymentPage from './components/TestDeploymentPage';

const PageContent: React.FC = () => {
  const { currentPage } = useWizard();
  switch (currentPage) {
    case 'org-units':            return <OrgUnitsLocationsPage />;
    case 'migration-progress':   return <MigrationProgressPage />;
    case 'site-mapping':         return <OrgAssignmentPage />;
    case 'group-reconciliation': return <GroupReconciliationPage />;
    case 'test-deployment':      return <TestDeploymentPage />;
    case 'deployment':           return <DeploymentPage />;
    case 'post-deployment':      return <PostDeploymentPage />;
    case 'platform-groups':      return <PlatformGroupsPage />;
    default:                     return <MigrationProgressPage />;
  }
};

const AppShell: React.FC = () => (
  <div className="app-layout">
    <Sidebar />
    <PageContent />
  </div>
);

const App: React.FC = () => (
  <OrgDataProvider>
    <WizardProvider>
      <AppShell />
    </WizardProvider>
  </OrgDataProvider>
);

export default App;
